import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import Button from 'components/Button'

import ContentHolder from '../../ui/ContentHolder'
import DefaultImage from './assets/background.jpg'
import styles from './styles.scss'

const imageUrl = ({ options }, images) => {
  if (options && options.download_image_id){
    const image = images[options.download_image_id]
    if (image && image.large_url){
      return image.large_url
    }
  }

  return DefaultImage
}

const Download = (props) => {
  const {
    artwork,
    brand: { colour_primary, colour_highlight },
    campaignProposal,
    images,
  } = props

  if (!artwork || !artwork.links) return null

  return (
    <div className={styles.root}>
      <ContentHolder>
        <h1>Your Proposal</h1>

        <p className={styles.intro}>
          We&apos;ve also prepared a comprehensive print document to read with even more information about the sale of
          your property. Please click to download it.
        </p>

        <div className={styles.imageHolder} style={{ backgroundImage: `url(${imageUrl(campaignProposal, images)})` }}>
          <Button
            icon={<FontAwesomeIcon icon={faDownload} />}
            text="Download Proposal"
            href={artwork.links.download_url}
            className={styles.button}
            size="large"
            style={{
              color: `#${colour_highlight}`,
              backgroundColor: `#${colour_primary}`,
              borderColor: `#${colour_primary}`,
              padding: '20px 30px',
            }}
            target="_blank"
          />
        </div>
      </ContentHolder>
    </div>
  )
}

Download.propTypes = {
  artwork: PropTypes.object,
  brand: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  images: PropTypes.object.isRequired,
}

export default Download
